'use client'

import styles from './Experimente.module.css';
import Button from "../../components/Button/Button";
import "../../components/Button/Button.css";
import classNames from "classnames";
import { usePathname } from 'next/navigation';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

const Experimente = () => {
    const pathname = usePathname();
    const navigate = useRouter();

    const isSpecificPage = pathname === "/Produtos/Corporativo";

    let urlExperimente = "/EuQuero";

    if (pathname === "/Produtos/EnsinoSuperior") {
        urlExperimente = "/EuQuero/SolicitarBVU";
    } else if (pathname === "/Produtos/EnsinoTecnico") {
        urlExperimente = "/EuQuero/SolicitarBVT";
    } else if (pathname === "/Produtos/Corporativo") {
        urlExperimente = "/EuQuero/SolicitarBVC";
    }

    return (
        <section className={styles.Experimente}>
            <div className="uiContainer">
                {isSpecificPage ? (
                    <div className={styles.dFlex}>
                        <div className={styles.textoExperimente}>
                            <h2 className={styles.title} tabIndex={0}>
                                Experimente nossa plataforma <span className={styles.corp}>por 30 dias</span>
                            </h2>
                            <p tabIndex={0}>
                                Descubra como nossa solução digital completa pode transformar suas leituras e estudos, com acesso a uma vasta coleção de recursos educativos ao seu alcance.
                            </p>
                            <div className={styles.dFlexButtons}>
                                <Link href={urlExperimente} aria-label="Eu quero experimentar a Biblioteca Virtual" className={classNames('btnPadrao', 'btnYellowCorp')}>
                                    Experimente
                                </Link>
                                <Link href="/Contato" aria-label="Acessar Página Contato" className={classNames('btnPadrao', 'btnBlue800')}>
                                    Fale Conosco                                    
                                </Link>
                            </div>
                        </div>
                        <div className={styles.imgExperimente}>
                            <img tabIndex={0} src="/images/img-experimente-corp.png" alt="Rapaz de óculos com celular e cadernos" loading='lazy'/>
                        </div>
                    </div>
                ) : (
                    <div className={styles.dFlex}>
                        <div className={styles.imgExperimente}>
                            <img tabIndex={0} src="/images/img-experimente.png" alt="Rapaz de óculos com celular e cadernos" loading='lazy'/>
                        </div>
                        <div className={styles.textoExperimente}>
                            <h2 className={styles.title} tabIndex={0}>
                                Experimente nossa plataforma <span>por 30 dias</span>
                            </h2>
                            <p tabIndex={0}>
                                Descubra como nossa solução digital completa pode transformar suas leituras e estudos, com acesso a uma vasta coleção de recursos educativos ao seu alcance.
                            </p>
                            <div className={styles.dFlexButtons}>
                                <Link href={urlExperimente} className={classNames('btnPadrao', 'btnBlueExperimente')} aria-label='Ir para página Experimente'>Experimente</Link>
                                
                                <Link href="/Contato" className={classNames('btnPadrao', 'btnBlue')} aria-label='Fale Conosco pela página de Contato' >Fale Conosco</Link>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};

export default Experimente;
